import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {withStyles} from '@material-ui/core/styles'
import {getOrientation} from 'get-orientation/browser'
import {getRotatedImage} from '../utils/canvasUtils'
import {styles} from '../styles/styles'
import Preview from '../Preview'
import CropperWrapper from "./CropperWrapper/";
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import getTypeFromBase64 from '../../../../helpers/getTypeFromBase64'
import * as toastRoutines from "../../../../sagas/routines/toastRoutines";
const ORIENTATION_TO_ANGLE = {
    '3': 180,
    '6': 90,
    '8': -90,
}

const Selection = ({ requiredType, closeModal, classes, recommended, aspectRatio, handleSuccess, postSelectionButtonText = 'Upload' }) => {
    const dispatch = useDispatch()
    const [imageSrc, setImageSrc] = React.useState(null)

    const [_, setCroppedArea] = useState(null);
    const [base64Img, setBase64Img] = useState(null)

    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            let imageDataUrl = await readFile(file)
            // apply rotation if needed
            const orientation = await getOrientation(file)
            const rotation = ORIENTATION_TO_ANGLE[orientation]
            const extractedType = getTypeFromBase64(imageDataUrl);

            if (rotation) {
                imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
            }
            if (requiredType) {
                let error = false;
                switch (requiredType) {
                    case 'png':
                        if (extractedType !== 'png') {
                            error = true;
                        }
                        break;
                    case 'jpg':
                    case 'jpeg':
                        if (extractedType !== 'jpg' && extractedType !== 'jpeg') {
                            error = true;
                        }
                        break;
                }
                if(error) {
                    dispatch(toastRoutines.setToastError(`Image must be of type .${requiredType}`));
                    return
                }
            }

            setImageSrc(imageDataUrl)
        }
    }

    return (
        <section id={'selection'}>
            {imageSrc ? (
                <section className={classes.wrapper}>
                <CropperWrapper
                    handleCroppedImgGenerated={(base64)=>{
                        setBase64Img(base64)
                    }}
                    setCroppedArea={setCroppedArea}
                    imageSrc={imageSrc}
                    recommended={recommended}
                    classes={classes}
                    aspectRatio={aspectRatio}/>
                 <Preview
                     closeModal={closeModal}
                     postSelectionButtonText={postSelectionButtonText}
                     handleSuccess={handleSuccess}
                     base64={base64Img}/>
                </section>
            ) : (
                <div style={{display:'flex', flexDirection:'column', textAlign:'center'}}>
                    <div id={'file-input-wrapper'}>
                        <label htmlFor={'file-upload'}>
                        <CloudUploadOutlined/>
                        </label>
                        <input id={'file-upload'} type="file" onChange={onFileChange} accept="image/*" />
                    </div>
                    <p><i>Recommended dimensions are <br/> at least <strong>{recommended.width}px x {recommended.height}px</strong></i></p>
                    {requiredType && <p style={{color:'red'}}>Required file type is {requiredType} </p>}

                </div>
            )}
        </section>
    )
}

function readFile(file) {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
    })
}

const StyledSelection = withStyles(styles)(Selection)

export default StyledSelection;